import PropTypes from 'prop-types';
import BetStatusIconImpl from './bet-status-icon.js';
import MojitoCore from 'mojito/core';

const { UIView } = MojitoCore.Presentation;

/**
 * Renders an icon representing the settlement status of a bet or leg.
 * The appropriate icon is selected based on the provided status key.
 *
 * @class BetStatusIcon
 * @memberof Mojito.Presentation.Components
 */

/**
 * `BetStatusIcon` component prop types.
 *
 * @property {string} status - The settlement status key used to select the icon to display (e.g. 'lost', 'open', 'void', 'won', 'cashedOut', 'saved', 'placed').
 *
 * @memberof Mojito.Presentation.Components.BetStatusIcon
 */
const propTypes = {
    status: PropTypes.string.isRequired,
};

export default UIView('BetStatusIcon', BetStatusIconImpl, propTypes);
